<div class="wrap">
  <div class="table-container">
    <app-isp-assigned-table
      [projectData]="ispAssigned"
      [loader]="loader"
      (reloadDataEmitter)="getIspAssigned()"
    ></app-isp-assigned-table>
  </div>
</div>